import React, {Component} from "react";
import * as messageConstants from "../../shared/messages";
import './index.scss';

export class AzureAdTableLoading extends Component {
  render() {
    return (
        <img src="images/spinnygreyontransparent_48x48.gif"
             alt={messageConstants.LOADING_AZURE_AD_INTEGRATIONS}/>
    )
  }
}